<app-breadcrumbs></app-breadcrumbs>
<hr />

<p-confirmDialog header="Confirmation"></p-confirmDialog>


<p-table [columns]="cols" [value]="customers" selectionMode="single" [(selection)]="selectedCustomer" dataKey="id"
  [resizableColumns]="true" [reorderableColumns]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 34px">#</th>
      <th *ngFor="let col of columns" pResizableColumn pReorderableColumn
        [style]="col.width ? ' width:' + col.width : ''">
        {{ col.header }}
      </th>
      <th style="width: 150px">Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
    <tr [pSelectableRow]="rowData" [pSelectableRowDblClick]="rowData" (dblclick)="gotoRoute(rowData)">
      <td>{{ index + 1 }}</td>
      <td *ngFor="let col of columns" style="white-space: normal">
        <ng-container *ngIf="col.type === 'Date'">
          {{ formatDate(rowData.attributes[col.field]) }}
        </ng-container>
        <ng-container *ngIf="col.type !== 'Date'">
          {{ rowData.attributes[col.field] }}
        </ng-container>
      </td>
      <td>
        <span pTooltip="Courses" tooltipPosition="top" style="display: inline-block">
          <button pButton type="button" icon="fas fa-forward" (click)="gotoRoute(rowData)"></button> </span>&nbsp;
        <span pTooltip="Edit" tooltipPosition="top" style="display: inline-block">
          <button pButton type="button" icon="fas fa-edit" (click)="showEditDialog(rowData)"></button> </span>&nbsp;
        <span pTooltip="Delete" tooltipPosition="top" style="display: inline-block">
          <button pButton type="button" icon="fas fa-times" class="p-button-danger"
            (click)="deleteCustomer(rowData)"></button>
        </span>
      </td>
    </tr>
  </ng-template>
  <!-- <ng-template pTemplate="rowexpansion" let-rowData>
        <td colspan="6">
            <app-levels [app]="rowData" [appLevels]="rowData.levels"></app-levels>
        </td>
    </ng-template> -->
  <ng-template pTemplate="summary">
    <div class="right">
      <span><button pButton type="button" label="New Customer" icon="fas fa-plus"
          (click)="newCustomer($event)"></button></span>
    </div>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + 1">
        <div style="text-align: center">
          Loading customers / No customers found
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<br />
